
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/[category]/faq/[article]",
      function () {
        return require("private-next-pages/news/[category]/faq/[article].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/[category]/faq/[article]"])
      });
    }
  